var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as __au2ViewDef from './container-animation-transition.html';
import { customElement } from '@aurelia/runtime-html';
const fNames = [
    // tslint:disable-next-line:max-line-length
    'Ford', 'Arthur', 'Trillian', 'Sneezy', 'Sleepy', 'Dopey', 'Doc', 'Happy', 'Bashful', 'Grumpy', 'Mufasa', 'Sarabi', 'Simba', 'Nala', 'Kiara', 'Kovu', 'Timon', 'Pumbaa', 'Rafiki', 'Shenzi'
];
const lNames = [
    // tslint:disable-next-line:max-line-length
    'Prefect', 'Dent', 'Astra', 'Adams', 'Baker', 'Clark', 'Davis', 'Evans', 'Frank', 'Ghosh', 'Hills', 'Irwin', 'Jones', 'Klein', 'Lopez', 'Mason', 'Nalty', 'Ochoa', 'Patel', 'Quinn', 'Reily', 'Smith', 'Trott', 'Usman', 'Valdo', 'White', 'Xiang', 'Yakub', 'Zafar'
];
let ContainerAnimationTransition = class ContainerAnimationTransition {
    constructor() {
        this.ctHeight = 300;
        this.ctWidth = 600;
        this.ctBorder = 0;
        this.ctBorderCss = '15px solid royalblue';
        this.ctWidthCss = '50%';
        this.ctHeightCss = '50%';
        this.people = [];
        this.push(500);
    }
    push(count = 30) {
        while (count-- > 0) {
            this.people.push({
                fname: fNames[Math.floor(Math.random() * fNames.length)],
                lname: lNames[Math.floor(Math.random() * lNames.length)]
            });
        }
    }
    resizeAndMutate() {
        const hSeed = Math.random();
        const wSeed = Math.random();
        const borderSeed = Math.random();
        this.ctHeight = hSeed > 0.1 ? (200 + Math.round(Math.random() * 400)) : 0;
        this.ctWidth = wSeed > 0.1 ? (200 + Math.round(Math.random() * 400)) : 0;
        this.ctBorder = borderSeed > 0.1 ? Math.round(Math.random() * 50) : 0;
        const collectionSeed = Math.random();
        if (collectionSeed > 0.1) {
            this.people.splice(0, Math.floor(Math.random() * this.people.length));
            this.push(Math.round(Math.random() * 50));
        }
        else {
            this.people = collectionSeed > 0.8 ? undefined : collectionSeed > 0.7 ? null : [];
        }
    }
};
ContainerAnimationTransition = __decorate([
    customElement(__au2ViewDef),
    __metadata("design:paramtypes", [])
], ContainerAnimationTransition);
export { ContainerAnimationTransition };
